import { Entity } from './entity';
import { Ship } from '../model/ship'
import clone from 'immutability-helper'
import { WorldGrid } from './world-grid';
import { Point, equals } from '../math/point';
import { Vector, add } from '../math/vector';

export class World {
  readonly turnCount: number = 0
  readonly deltaTime: number = 0
  readonly pointer = new Point(0, 0)
  readonly selected: boolean = false

  constructor(
    readonly grid: WorldGrid,
    readonly ship: Ship,
    readonly enemies: Ship[]
  ) {}

  getBody(id: string): Entity | undefined {
    if (this.ship.name === id) {
      return this.ship
    }

    return this.enemies.find(x => x.name === id)
  }

  setBody(id: string, body: Entity): World {
    if (this.ship.name === id) {
      const ship = updateEntity(this.ship, body)
      return this.setPlayerShip(ship)
    }

    const ship = this.enemies.find(x => x.name === id)
    if (ship !== undefined) {
      const ship0 = updateEntity(ship, body)
      return this.setShip(ship0)
    }

    return this
  }

  getShip(id: string): Ship | undefined {
    if (this.ship.name === id) {
      return this.ship
    }

    return this.enemies.find(x => x.name === id)
  }

  setShip(newShip: Ship): World {
    if (this.ship.name === newShip.name) {
      return this.setPlayerShip(newShip)
    }

    const index = this.enemies.findIndex(s => {
      return (s.name === newShip.name)
    })

    // if (newShip.hullPoints > 0 ) {
      const newEnemies = clone(this.enemies, {[index]: {$set: newShip}})
      return clone(this as World, {enemies: {$set: newEnemies}})
    // } else {
    //   newShip.sprite.image.destroy()
    //   const newEnemies = clone(this.enemies, {$splice: [[index, 1]]})
    //   return clone(this as World, {enemies: {$set: newEnemies}})
    // }
  }

  setPlayerShip(ship: Ship): World {
    return clone(this as World, {ship: {$set: ship}})
  }

  destroyShip(id: string): World {
    const newShip = this.getShip(id)
    if (newShip !== undefined) {
      newShip.sprite.image.destroy()
      if (this.ship.name === newShip.name) {
        return this.setPlayerShip(newShip)
      }

      const index = this.enemies.findIndex(s => {
        return (s.name === newShip.name)
      })
      const newEnemies = clone(this.enemies, {$splice: [[index, 1]]})
      return clone(this as World, {enemies: {$set: newEnemies}})
    }
    return this
  }

  update(elapsed: number): World {
    // const removedEnemies = this.enemies.filter(s => (s.hullPoints <= 0))
    // removedEnemies.forEach(s => s.sprite.image.destroy())
    // const newEnemies = this.enemies.filter(s => (s.hullPoints > 0))
    return this //clone(this as World, {enemies: {$set: newEnemies}, deltaTime: {$set: elapsed}})
  }

  snap(p: Point): Point {
    return this.grid.snap(p)
  }

  setOrgin(p: Point): World {
    const newGrid = this.grid.setOrigin(p)
    return clone(this as World, { grid: {$set: newGrid}})
  }

  moveOrgin(v: Vector): World {
    const p = add(this.grid.origin, v)
    const newGrid = this.grid.setOrigin(p)
    return clone(this as World, { grid: {$set: newGrid}})
  }

  endPhase(): World {
    const ship0 = this.ship.endPhase()
    const enemies0 = this.enemies.map(e => e.endPhase())

    return clone(this as World, { ship: {$set: ship0}, enemies: {$set: enemies0}, turnCount: {$set: this.turnCount+1} })
  }

  protected findShip(p: Point): Ship | undefined {
    if (equals(p, this.ship.position)) {
      return this.ship
    }
    return this.enemies.find(enemy => equals(p, enemy.position));
  }

  protected findEnemyShipDestination(p: Point): Ship | undefined {
    return this.enemies.find(enemy => {
      if ((enemy.destination !== undefined) && equals(p, enemy.destination)) {
        return enemy
      }
    });
  }

  enemyShipCanMove(p: Point, ship: Ship) {
    const space = this.findEnemyShipDestination(p)
    if ((space === undefined) && !equals(p, this.ship.position)) {
      return ship.canMove(p)
    }
    return false
  }

  shipCanMove(p: Point, ship: Ship) {
    const space = this.enemies.find(enemy => equals(p, enemy.position));
    if (space === undefined) {
      return ship.canMove(p)
    }
    return false
  }
}

function updateEntity(ship: Ship, body: Entity): Ship {
  const ship0 = clone(ship, {
      position: {$set: body.position},
      heading: {$set: body.heading}})
  return ship0
}
